module.exports = __webpack_public_path__ + "img/重楼.1aad4927.jpg";